export default function (node, key, target, easing, duration = 200, callback = () => undefined) {
    const startTime = Date.now();
    const offset = node[key];
    const gap = target - offset;
    let interrupt = false;
    const step = () => {
        const elapsed = Date.now() - startTime;
        const percentage = elapsed / duration;
        if (interrupt) {
            return;
        }
        if (percentage > 1) {
            node[key] = target;
            cleanup();
            callback();
            return;
        }
        node[key] = easing(elapsed, offset, gap, duration);
        requestAnimationFrame(step);
    };
    const cancel = () => {
        interrupt = true;
        cleanup();
        callback();
        return;
    };
    const cleanup = () => {
        node.removeEventListener('wheel', cancel);
        node.removeEventListener('touchstart', cancel);
    };
    node.addEventListener('wheel', cancel, { passive: true });
    node.addEventListener('touchstart', cancel, { passive: true });
    step();
    return cancel;
}
